import { useEffect, useState } from "react";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { fmtMoney } from "../../../lib/format";
import { Panel } from "../../../components/common/Page";

// Invoiced sales per salesman: this year to date vs the same period last year
export const SalesmenPanel = () => {
  const { t } = useI18n();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/stats/salesmen").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows || !rows.length) return null;
  return (
    <Panel title={t("stats.salesmen")} testId="dash-salesmen">
      {!rows.length ? <p className="text-sm text-slate-400">{t("stats.empty")}</p> : (
        <table className="w-full text-sm"><thead><tr className="text-left text-xs text-slate-500"><th className="py-1">{t("stats.salesman")}</th><th className="py-1 text-right">{t("stats.ytdShort")}</th><th className="hidden py-1 text-right sm:table-cell">{t("stats.prevShort")}</th><th className="py-1 text-right">Δ</th><th className="hidden py-1 text-right sm:table-cell">{t("stats.customers")}</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.salesman} className="tabular-nums" data-testid={`dash-salesman-${r.salesman}`}>
                <td className="py-1.5 font-medium text-navy">{r.name}</td>
                <td className="py-1.5 text-right font-semibold text-navy">{fmtMoney(r.ytd_net)}</td>
                <td className="hidden py-1.5 text-right text-slate-500 sm:table-cell">{fmtMoney(r.ytd_prev_net)}</td>
                <td className={`py-1.5 text-right font-semibold ${r.change_pct == null ? "text-slate-400" : r.change_pct >= 0 ? "text-emerald-700" : "text-rose-700"}`}>{r.change_pct == null ? "—" : `${r.change_pct > 0 ? "+" : ""}${r.change_pct}%`}</td>
                <td className="hidden py-1.5 text-right text-slate-500 sm:table-cell">{r.customers}</td>
              </tr>
            ))}
          </tbody></table>
      )}
    </Panel>
  );
};
